import React, { useState } from 'react';
import { 
  Dialog, 
  DialogContent, 
  DialogActions,
  Button,
  Autocomplete,
  TextField,
  Typography,
  Box
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useHistory } from 'react-router';
import { enqueueSnackbar } from 'notistack';

function OrganizationSelector ({ open, onClose }) {
  const { currentKratosSession, organizations, currentOrganization, switchOrganization } = useAuth();
  const history = useHistory();
  const [selectedOrg, setSelectedOrg] = useState(null);

  if (!currentKratosSession?.active || !organizations?.length) {
    return null;
  }

  const handleOrganizationChange = async () => {
    if (selectedOrg) {
      onClose();
      await switchOrganization(selectedOrg, true);
      enqueueSnackbar(
        `Switched to organization ${selectedOrg.name}`,
        { 
          variant: 'success',
          autoHideDuration: 3000
        }
      );
      history.push('/');
    }
  };

  const otherOrganizations = organizations.filter(org => org.id !== currentOrganization?.id);
  const hasOtherOrgs = otherOrganizations.length > 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle2" color="text.secondary">Current Organization</Typography>
          <Typography variant="h6" sx={{ mb: 2 }}>{currentOrganization?.name}</Typography>
          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>Switch to:</Typography>
          {hasOtherOrgs ? (
            <Autocomplete
              value={selectedOrg}
              onChange={(event, newValue) => {
                setSelectedOrg(newValue);
              }}
              options={otherOrganizations}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Search organizations..."
                  variant="outlined"
                />
              )}
              fullWidth
              disableClearable
              isOptionEqualToValue={(option, value) => option.id === value.id}
            />
          ) : (
            <Typography color="text.secondary">
              You don't belong to any other organizations
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        {hasOtherOrgs && (
          <Button 
            onClick={handleOrganizationChange} 
            variant="contained" 
            color="primary"
            disabled={!selectedOrg}
          >
            Change
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default OrganizationSelector; 